const companyFrPages = {
  selectEntityPage_Selling: 'Vente',
  selectEntityPage_Selling_Subtitle: 'Commencez à vendre plus intelligemment',
  selectEntityPage_Management: 'Gestion',
  selectEntityPage_Management_Subtitle: 'Commencez à gérer en douceur',
  selectEntityPage_Growing: 'Croissance',
  selectEntityPage_Growing_Subtitle: 'Commencez à grandir rapidement',
  // notifications page
  notificationsPage_title: 'Notifications',
  notificationsPage_Emails: 'E-mails',
  notificationsPage_Sms: 'SMS',
  notificationsPage_Notifications: 'Notifications',
  notificationsPage_EmailSubject: 'Objet',
  notificationsPage_ToEmail: 'Pour envoyer un e-mail',
  notificationsPage_FromEmail: 'Depuis un e-mail',
  notificationsPage_Error: 'Erreur',
  notificationsPage_SentOn: 'Envoyé le',
  notificationsPage_EmailContent: `Contenu de l'e-mail`,
  notificationsPage_PhoneNumber: 'Numéro de téléphone',
  notificationsPage_CountryCode: 'Code pays',
  notificationsPage_Message: 'Message',
  notificationsPage_SmsProvider: 'Fournisseur SMS',
  notificationsPage_SenderName: `Nom de l'expéditeur`,
  notificationsPage_IsEnable: 'Est activé',
  notificationsPage_ToUser: `À l'utilisateur`,
  // company settings page
  companySettingsPage_Title: `Paramètres de l'entreprise`,
  companySettingsPage_CompanyGeneralInfo: 'Informations générales sur la société',
  companySettingsPage_General: 'Général',
  companySettingsPage_CarrieCode: 'Code de transporteur',
  companySettingsPage_DateFormat: 'Format de date',
  companySettingsPage_TimeFormat: `Format de l'heure`,
  companySettingsPage_InsuranceExpirationDays: `Jours d'expiration d'assurance`,
  companySettingsPage_DistanceUnit: 'Unité de distance',
  companySettingsPage_WeightUnit: 'Unité de poids ',
  companySettingsPage_IntervalDays: 'Intervalle de jours',
  companySettingsPage_TripRangeValue: 'Valeur de la plage de trajet',
  companySettingsPage_OrangeBfuSerId: `Nom d'utilisateur Orange BF`,
  companySettingsPage_OrangeBfPassword: 'Mot de passe Orange BF',
  companySettingsPage_SmsServiceUserName: `Utilisateur du service SMS`,
  companySettingsPage_SmsServicePassword: 'Mot de passe du service SMS',
  companySettingsPage_ActionCasse: 'Action caisse',
  companySettingsPage_NbrVoyage: 'Voyage Gratuit',
  companySettingsPage_TripSearchHoursGapSetup: 'Écart de recherche des trajets (heures)',
  companySettingsPage_TripSalesLimitTime: 'Délai limite de vente',
  companySettingsPage_TripBoardingLimitTime: 'Délai limite d\'embarquement',
  companySettingsPage_CompanyLogoImage: `Logo de l'entreprise`,
  companySettingsPage_ShipmentNotificationAmount: `Montant de la notification d'expédition`,
  companySettingsPage_IsShipmentNotificationSenderEnabled: `Envoyer une notification d'expédition à l'expéditeur`,
  companySettingsPage_IsShipmentNotificationReceiverEnabled: `Envoyer la notification d'expédition au destinataire`,
  companySettingsPage_ValiditySettings: 'Paramètres de validité',
  companySettingsPage_TicketExpirationDays: 'Jours de validité du billet',
  companySettingsPage_BookPayLaterSettings: 'Paramètres de réservation et de paiement ultérieur',
  companySettingsPage_BookingAllowedTime: 'DBooking Allowed Time',
  companySettingsPage_BookingConfirmationLimitTime: 'Délai de confirmation des réservations',
  companySettingsPage_BookingReminderLimitTime: 'Délai de rappel des réservations',
  companySettingsPage_OnDepartureTime: `À l'heure de départ`,
  companySettingsPage_OnBookingTime: `À l'heure de la réservation`,
  companySettingsPage_IsSeatReleasedOnDepartureTime: 'Libération des sièges',
  companySettingsPage_SettingsCompanyDetails: `Détail des paramètres de l'entreprise`,
  companySettingsPage_DefaultEmail: 'E-mail par défaut',
  companySettingsPage_NoCc: 'Sans copie',
  companySettingsPage_NoIfu: `Pas d'IFU`,
  companySettingsPage_EmployerNo: `N° d'employeur`,
  companySettingsPage_TripFillUpThresholdValue: 'Valeur seuil de déclenchement',
  companySettingsPage_CompanyName: `Nom de l'entreprise`,
  companySettingsPage_UpdateSuccess: 'Mise à jour réussie !',
  ShipmentInsuranceSettingType_FlatBase: 'Base plate',
  ShipmentInsuranceSettingType_PercentageBase: 'Base de pourcentage',
  ShipmentInsuranceSettingType_RangeBase: 'Base de gamme',
  companySettingsPage_ShipmentInsuranceSettings: `Paramètres d'assurance d'expédition`,
  companySettingsPage_ShipmentInsuranceSettingType: `Paramètres d'assurance`,
  companySettingsPage_IsShipmentMinimumRangeValue: `Appliquer la valeur de plage minimale d'expédition`,
  companySettingsPage_AddRariff: 'Ajouter un tarif',
  companySettingsPage_IsPercentageAmount: 'Est un pourcentage',
  companySettingsPage_RangeValueCannotOverlapping: 'Les valeurs de plage ne peuvent pas se chevaucher',
  companySettingsPage_FromLessThanTo: 'De ne doit pas être inférieur à À.',
  PaymentPartnerNotAvailable: "Cet opérateur ou cette banque n'est pas disponible dans le pays de la compagnie.",
  companySettingsPage_AccountEntity: 'Entité de compte',
  companySettingsPage_OperatorBank: 'Opérateur / Banque',
  companySettingsPage_AccountOwner: 'Propriétaire du compte',
  companySettingsPage_AccountNumber: 'Numéro de compte',
  companySettingsPage_AccountType: 'Type de compte',
  companySettingsPage_Accounts: 'Comptes',
  companySettingsPage_AccountNumberMustBeNumer: `Le numéro de compte n'accepte que les chiffres`,
  companySettingsPage_AddAccount: 'Ajouter un compte',
  companySettingsPage_UpdateAccount: 'Mettre à jour le compte',
  companySettingsPage_Notifications: 'Notifications',
  companySettingsPage_TicketSettings: 'Paramètres des billets',
  companySettingsPage_CompanyDisplayName: `Nom d'affichage de l'entreprise`,
  companySettingsPage_CompanyAddress: `Adresse de l'entreprise`,
  companySettingsPage_CompanyLogoImageUrl: `Logo de l'entreprise`,
  companySettingsPage_CreateTicketSetting: 'Créer un paramètre de ticket',
  companySettingsPage_UpdateTicketSetting: 'Mettre à jour les paramètres du ticket',
  companySettingsPage_NotificationContacts: 'Contacts de notification',
  companySettingsPage_SMSServiceSetting: 'Paramètres du service SMS',
  companySettingsPage_ContactName: 'Nom du contact',
  companySettingsPage_ContactPhoneNumber: 'Numéro de téléphone de contact',
  companySettingsPage_ServiceUrl: 'URL du service',
  // Tariff Parameters
  companySettingsPage_TariffParamsSarchText: 'Nom du tarif, description...',
  companySettingsPage_TariffCategory: 'Catégorie tarifaire',
  companySettingsPage_TariffParams_Name: 'Nom du tarif',
  companySettingsPage_CreateTariffParams: 'Créer les paramètres tarifaires',
  companySettingsPage_UpdateTariffParams: 'Mettre à jour les paramètres tarifaires',
  companySettingsPage_TariffParameters: 'Paramètres tarifaires',
  // SellOnTheGoFareConfiguration
  companySettingsPage_SellOnTheGo: 'Vendre en déplacement - configuration tarifaire',
  companySettingsPage_SellOnTheGoFromKms: 'De kms',
  companySettingsPage_SellOnTheGoToKms: 'En kms',
  companySettingsPage_SellOnTheGoTariffValue: 'Valeur tarifaire',
  companySettingsPage_SellOnTheGoIsInRate: 'Est dans le tarif',
  companySettingsPage_AddFareConfigurations: 'Ajouter une configuration tarifaire',
  companySettingsPage_UpdateFareConfigurations: 'Mettre à jour la configuration des tarifs',
  companySettingsPage_SellOnTheGoFromKmsLessThanToKms: 'De kms doit être inférieur à A kms',
  // Subscriptions page
  subscriptionsPage_Title: 'Abonnements',
  subscriptionsPage_PlanFeature: 'Planifier la fonctionnalité',
  subscriptionsPage_Registers: 'Registres',
  subscriptionsPage_PaymentMethod: 'Mode de paiement',
  subscriptionsPage_PerMonth: 'Par mois',
  subscriptionsPage_LearnMore: 'En savoir plus',
  subscriptionsPage_Subscribe: `S'abonner`,
  subscriptionsPage_NotAvailable: 'Non disponible',
  subscriptionsPage_PlanMonthlyFees: 'Frais mensuels du forfait : ',
  subscriptionsPage_TotalAmount: 'Montant total : ',
  subscriptionsPage_PlanComponentFees: 'Frais des composants du plan : ',
  subscriptionsPage_SubscribeNow: `S'abonner maintenant`,
  subscriptionsPage_Note: 'Remarque',
  subscriptionsPage_NoteDetail: `S'abonner à un nouveau plan entraînera la perte de la validité et des fonctionnalités de l'ancien plan. Vous serez facturé XOF 0 par mois
  base pour cet abonnement.`,
  subscriptionsPage_FreePlanNote: `Ce plan ne peut pas être souscrit car il s'agit d'un plan gratuit ou le nombre de registres dans votre plan actuel dépasse le nombre de registres dans ce plan`,
  subscriptionsPage_PlanExpiresOn: `Le forfait expire le : `,
  subscriptionsPage_NoData: 'Aucune donnée',
  // stations page
  stationsPage_Title: 'Gares',
  stationsPage_AddStation: 'Ajouter une station',
  stationsPage_UpdateStation: 'Mettre à jour la station',
  stationsPage_StationName: 'Nom de la station',
  stationsPage_StationCode: 'Code de la station',
  stationsPage_LatitudeLongitude: 'Latitude / longitude',
  stationsPage_QuartierName: 'Nom du quartier',
  stationsPage_CityRegionCountry: 'Ville-région-pays',
  stationsPage_StationAdministrator: 'Administrateur de la station',
  stationsPage_StationSupervisor: 'Superviseur de la station',
  stationsPage_StartingBalance: 'Solde de départ',
  stationsPage_Latitude: 'Latitude',
  stationsPage_Longitude: 'Longitude',
  stationsPage_Quartier: 'Quartier',
  stationsPage_ExpenseArpprover: 'Approbateur des dépenses',
  stationsPage_IsConnectionStation: 'Est une station de connexion',
  stationsPage_StationImageUrl: 'Image de la station',
  stationsPage_displayPhoneNumbers: 'Numéro de téléphone',
  // station printer
  stationsPage_DeviceName: `Nom de l'appareil`,
  stationsPage_PrinterCompany: `Société de l'imprimante`,
  stationsPage_PrintType: `Type d'impression`,
  stationsPage_PrinterConfigurations: `Configurations de l'imprimante`,
  stationsPage_AddPrinter: 'Ajouter une imprimante',
  stationsPage_UpdatePrinter: `Mettre à jour l'imprimante`,
  // station Balance
  stationsPage_CurrentBalance: 'Solde actuel',
  stationsPage_ManageBalance: 'Gérer le solde',
  stationsPage_StationBalance: 'Solde de la station',
  stationsPage_StationBalanceEntityType: `Type d'entité`,
  stationsPage_StationBalanceEvent: 'Événement',
  stationsPage_StationBalanceStationAction: 'Action de la station',
  stationsPage_StationBalanceAmount: 'Montant impliqué',
  stationsPage_StationBalanceDocuments: 'Documents',
  // staffs page
  staffsPage_Title: 'Personnes',
  staffsPage_AddStaff: 'Ajouter du personnel',
  staffsPage_UpdateStaff: 'Mettre à jour le personnel',
  staffsPage_EmployeeId: `Identifiant de l'employé`,
  staffsPage_EmployeeCode: `Code de l'employé`,
  staffsPage_EmployeeCategory: `Catégorie d'employés`,
  staffsPage_JobTitle: 'Titre du poste',
  staffsPage_Roles: 'Rôles',
  staffsPage_CanLogin: 'Peut se connecter',
  staffsPage_SearchText: 'Nom du personnel, e-mail....',
  staffsPage_JoiningDate: `Date d'adhésion`,
  staffsPage_IgrParts: 'Pièces IGR',
  staffsPage_ContractType: 'Type de contrat',
  staffsPage_Seniority: 'ancienneté',
  staffsPage_CnpsId: 'Identifiant CNPS',
  staffsPage_Employment: 'Emploi',
  staffsPage_SalaryCategory: 'Catégorie de salaire',
  staffsPage_Qualification: 'Qualification',
  staffsPage_StaffImage: 'Image du personnel',
  staffsPage_PaymentMethod: 'Mode de paiement ',
  staffsPage_Cash: 'espèces',
  staffsPage_CashPaymentPortion: 'Partie de paiement en espèces (%)',
  staffsPage_MMAccountNumber: 'Numéro de compte Mobile Money',
  staffsPage_AccountNumber: 'Numéro de compte',
  staffsPage_MobilePaymentPortion: 'Partie de paiement mobile (%)',
  staffsPage_BankAccountNumber: 'Numéro de compte bancaire',
  staffsPage_BankAccountPortion: 'Portion de paiement bancaire (%)',
  staffsPage_EmployeeType: `Type d'employé`,
  staffsPage_ExportStaffs: 'Exporter le personnel',
  // ticket class page
  ticketClassesPage_Title: 'Classes de billets',
  ticketClassesPage_BaseTicketClassName: 'Nom de la classe de base du billet',
  ticketClassesPage_Name: 'Nom',
  ticketClassesPage_SeatColor: 'Couleur du siège',
  ticketClassesPage_CreateTicketClass: 'Créer une classe de billet',
  ticketClassesPage_UpdateTicketClass: 'Mettre à jour la classe du billet',
  // seat model page
  seatModelsPage_Title: 'Modèles de sièges',
  seatModelsPage_SeatingModelName: 'Nom',
  seatModelsPage_SeatingModelRef: 'Référence du modèle de siège',
  seatModelsPage_NoOfRows: 'Nombre de lignes',
  seatModelsPage_SeatingType: 'Type',
  seatModelsPage_CreateSeatModel: 'Créer un modèle de siège',
  seatModelsPage_UpdateSeatModel: 'Mettre à jour le modèle de siège',
  seatModelsPage_SeatInfo: 'Informations sur le siège',
  seatModelsPage_TicketClass: 'Classe de billet',
  seatModelsPage_SeatName: 'Nom du siège',
  seatModelsPage_RemoveSeat: 'Supprimer le siège',
  seatModelsPage_Save: 'Enregistrer',
  seatModelsPage_BusBasicInfo: 'Informations de base sur le bus',
  seatModelsPage_BusDesign: `Conception d'autobus`,
  seatModelsPage_BusSummary: 'Résumé',
  // bus model page
  busModelsPage_Title: 'Modèles de bus',
  busModelsPage_BusModelName: 'Nom du modèle',
  busModelsPage_BusBrandName: 'Nom de la marque',
  busModelsPage_ModelPower: 'Puissance du modèle',
  busModelsPage_modelYear: 'Année du modèle',
  busModelsPage_CreateBusModel: 'Créer des modèles de bus',
  busModelsPage_UpdateBusModel: 'Mettre à jour les modèles de bus',
  // buses page
  busesPage_Title: 'Bus',
  busesPage_BusName: 'Nom du bus',
  busesPage_SerialNo: 'Numéro de série',
  busesPage_ChassisNo: 'Numéro de châssis',
  busesPage_MotorPower: 'Puissance du moteur',
  busesPage_AcquisitionDate: `Date d'acquisition`,
  busesPage_BaggageCapacity: 'Capacité de bagages',
  busesPage_InitialColor: 'Couleur d\'origine',
  busesPage_PlateNumber: 'Numéro de plaque',
  busesPage_transportVendor: 'Fournisseur de transport',
  busesPage_PurchaseOrderDetail: 'N° de référence du bon de commande',
  busesPage_SeatingModel: 'Modèle de siège',
  busesPage_BusModel: 'Modèle de bus',
  busesPage_BusBrand: 'Marque du bus',
  busesPage_CreateBus: 'Créer un bus',
  busesPage_UpdateBus: 'Mettre à jour le bus',
  busesPage_OtherDetail: 'Autres détails',
  busesPage_SeatingDetail: 'Détail des sièges',
  busesPage_Summary: 'Résumé',
  busesPage_VendorDetail: 'Détail du fournisseur',
  busesPage_StaffList: 'Liste du personnel',
  busesPage_BusMode: 'Mode bus',
  busesPage_UploadDocuments: 'Télécharger des documents',
  busesPage_DocumentName: 'Nom du document',
  busesPage_FileName: 'Nom du fichier',
  busesPage_Documents: 'Documents',
  busesPage_Upload: 'Télécharger',
  busesPage_SelectFile: 'Sélectionner un fichier',
  // Bus station mappings
  busStationMappingsPage_Title: 'Affecter le bus aux gares',
  busStationMappingsPage_Bus: 'Car',
  busStationMappingsPage_Station: 'Gare',
  busStationMappingsPage_StartDate: 'Date de début',
  busStationMappingsPage_EndDate: 'Date de fin',
  busStationMappingsPage_CreateBusStationMapping: 'Affecter le bus aux gares',
  busStationMappingsPage_UpdateBusStationMapping: 'Mettre à jour le mappage des gares routières',
  // sms template page
  smsTemplatesPage_Title: 'Modèles SMS',
  smsTemplatesPage_Name: 'Nom',
  smsTemplatesPage_CultureCode: 'Code culturel',
  smsTemplatesPage_Content: 'Contenu',
  smsTemplatesPage_CreatTemplate: 'Créer un modèle de SMS',
  smsTemplatesPage_UpdateTemplaet: 'Mettre à jour le modèle de SMS',
  // passenger page
  passengersPage_Title: 'Passagers',
  passengersPage_IsTicketBookingAllowed: 'Réservation autorisée',
  passengersPage_SearchText: 'Nom, e-mail, téléphone du passager...',
  passengersPage_PassengerType: 'Type de passager',
  passengersPage_CreatePassenger: 'Créer un passager',
  passengersPage_UpdatePassenger: 'Mettre à jour le passager',
  passenger_UpdateAppliesToNextTrips: "La correction s'applique aux prochains voyages. Les billets déjà émis gardent leur identité : pour corriger un billet, faites une modification du billet depuis l'app caissier.",
  ticketHolder_Differs: "L'identité du billet diffère de la fiche du passager",
  ticketHolder_Ticket: "Billet (identité figée à la vente)",
  ticketHolder_Record: "Fiche",
  passengerHistory_Title: "Historique de la fiche",
  passengerHistory_Empty: "Aucune correction",
  passengerHistory_Date: "Date",
  passengerHistory_Source: "Origine",
  passengerHistory_Field: "Champ",
  passengerHistory_Old: "Avant",
  passengerHistory_New: "Après",
  passengerHistory_By: "Par",
  passengerHistory_Source_CounterSale: "Vente au guichet (confirmée)",
  passengerHistory_Source_BackOffice: "Back-office",
  passengerHistory_Source_CompanyCopy: "Copie propre à la compagnie",
  passengerHistory_Field_FirstName: "Prénom",
  passengerHistory_Field_LastName: "Nom",
  passengerHistory_Field_DateOfBirth: "Date de naissance",
  GenderType_Male: "Homme",
  GenderType_Female: "Femme",
  passengerHistory_Field_Gender: "Sexe",
  passengerHistory_Field_Phone: "Téléphone",
  passengerHistory_Field_EmailAddress: "E-mail",
  passengerHistory_Field_Copy: "Copie de la fiche commune",
  invalidPhones_Button: "Numéros invalides",
  invalidPhones_Title: "Fiches à numéro invalide",
  invalidPhones_Description: "Ces passagers ont un numéro incomplet ou invalide : la recherche au guichet ne les trouve pas. Saisissez le numéro complet ; il est enregistré au format international et la correction apparaît dans l'historique de la fiche.",
  invalidPhones_Empty: "Aucune fiche à numéro invalide",
  invalidPhones_Passenger: "Passager",
  invalidPhones_Current: "Numéro enregistré",
  invalidPhones_LastTravel: "Dernier voyage",
  invalidPhones_Correction: "Numéro corrigé",
  invalidPhones_NewNumber: "Numéro complet",
  invalidPhones_Corrected: "Numéro corrigé.",
  PassengerPhoneInvalid: "Numéro incomplet ou invalide : saisir le numéro complet.",
  withoutPhone_Button: "Ventes sans téléphone",
  withoutPhone_Title: "Ventes « Sans téléphone » par caissier",
  withoutPhone_Description: "Billets vendus avec le bouton « Sans téléphone », sur les 30 derniers jours.",
  withoutPhone_Empty: "Aucune vente sans téléphone",
  withoutPhone_Cashier: "Caissier",
  withoutPhone_Tickets: "Billets",
  withoutPhone_LastSale: "Dernière vente",
  // routes page
  routesPage_Title: 'Itinéraires',
  routesPage_Station: 'Gare',
  routesPage_RouteName: 'Nom de la route',
  routesPage_RouteInternalCode: 'Code interne de la route',
  routesPage_RouteType: `Type d'itinéraire`,
  routesPage_Origin: 'Origine',
  routesPage_Destination: 'Destination',
  routesPage_Distance: 'Distance (km)',
  routesPage_Stops: 'Arrêts',
  routesPage_SearchText: 'Nom de la route, code...',
  routesPage_CreateRoute: 'Créer un itinéraire',
  routesPage_UpdateRoute: `Mettre à jour l'itinéraire`,
  routesPage_IsRoundTrip: 'Est un aller-retour',
  routesPage_OriginCountry: `Pays d'origine`,
  routesPage_OriginStation: `Gare d'origine`,
  routesPage_DestinationCountry: 'Pays de destination',
  routesPage_DestinationStation: 'Gare de destination',
  routesPage_StopName: `Nom de l'arrêt`,
  routesPage_DistanceFromSource: 'Distance de la source',
  routesPage_AddStop: 'Ajouter un arrêt',
  routesPage_ManageStops: 'Gérer les arrêts',
  routesPage_RouteStops: `Arrêts de l'itinéraire`,
  // Baggage Tariffs Page
  // ticket tariff page
  ticketTariffsPage_Title: 'Tarifs des billets',
  ticketTariffsPage_BaseRate: 'Tarif de base',
  ticketTariffsPage_BaseRateReturn: 'Rendement du taux de base',
  ticketTariffsPage_Distance: 'Distance',
  ticketTariffsPage_Segment_Tariff: 'Tarif',
  ticketTariffsPage_Segment_Category: 'Catégorie',
  ticketTariffsPage_Segment_Code: 'Code',
  ticketTariffsPage_Segment_Name: 'Nom',
  ticketTariffsPage_Segment_ValueType: 'Type de valeur',
  ticketTariffsPage_Segment_Value: 'Valeur',
  ticketTariffsPage_Segment_Direction: 'Direction',
  ticketTariffsPage_Segment_SearchText: 'Catégorie, code, nom...',
  ticketTariffsPage_Segment_UpdateTariffParameter: 'Mettre à jour le paramètre tarifaire',
  // trips page
  tripsPage_Title: 'Voyages',
  tripsPage_Route: 'Itinéraire',
  tripsPage_SearchText: 'Nom du voyage...',
  tripsPage_DepartureDate: 'Date de départ',
  tripsPage_TripName: 'Nom du voyage',
  tripsPage_Source: 'Source',
  tripsPage_DepartureDateTime: 'Heure de la date de départ',
  tripsPage_Destination: 'Destination',
  tripsPage_ArrivalDateTime: `Date d'arrivée`,
  tripsPage_Duration: 'Durée (hh:mm)',
  tripsPage_NoOfStops: `Nb d'arrêts`,
  tripsPage_CreateTrip: 'Créer un voyage',
  tripsPage_UpdateTrip: 'Mettre à jour le voyage',
  tripsPage_IsRecurred: 'Est récurrent',
  tripsPage_TripGroups: 'Groupes de voyages',
  tripsPage_TripGroupName: 'Nom du groupe',
  tripsPage_CreateTripGroup: 'Créer un groupe de voyages',
  tripsPage_TripDetail: 'Détail du voyage',
  tripsPage_SeatingModel: 'Modèle de siège',
  tripsPage_Group: 'Groupe',
  tripsPage_RouteTripDetail: 'Détail du trajet',
  tripsPage_ConnectionPoint: 'Point de connexion',
  tripsPage_WantToRecurTrip: 'Voulez-vous répéter ce voyage ? ',
  tripsPage_RecurTripNote: `
                       <b>1</b>. Veuillez tenir compte des dates des plans de maintenance pour éviter tout chevauchement/mélange de répétition.<br/>
                       <b>2</b>. Veuillez supprimer les voyages qui se chevauchent immédiatement après leur programmation automatique pour éviter que l'utilisateur ne sélectionne le voyage pour la réservation.`,
  tripsPage_TripRecurrenceDays: 'Jour de récurrence du voyage : 30 jours',
  tripsPage_CopyTrip: 'Copier le voyage',
  // Discount
  discountsPage_Title: 'Remises',
  discountsPage_StartDate: 'Date de début',
  discountsPage_EndDate: 'Date de fin',
  discountsPage_Value: 'Valeur',
  discountsPage_ValueType: 'Type de valeur',
  discountsPage_beneficiaryType: 'Type de bénéficiaire',
  discountsPage_targetType: 'Type de cible',
  discountsPage_CreateDiscount: 'Créer une remise',
  discountsPage_UpdateDiscount: 'Mettre à jour la remise',
  discountsPage_Trip: 'Voyage',
  discountsPage_TicketClass: 'Classe de billet',
  discountsPage_TariffParameter: 'Paramètre tarifaire',
  discountsPage_Passengers: 'Passagères',

  // trip calendar
  tripsCalendarPage_Title: 'Calendrier des voyages',
  tripsCalendarPage_Country: 'Pays',
  tripsCalendarPage_Station: 'Gare',
  tripsCalendarPage_TripName: 'Nom du voyage',
  tripsCalendarPage_NumberOfPassenger: 'Nombre de passagers',
  tripsCalendarPage_Driver: 'Conducteur',
  tripsCalendarPage_CoDriver: 'Co Conducteur',
  tripsCalendarPage_BusName: 'Car',
  tripsCalendarPage_BusPlate: 'Numéro de plaque',
  tripsCalendarPage_NoOfSeats: 'Non. Attribuer des sièges',
  tripsCalendarPage_NoOfConflictedBooking: 'Non. Réservation conflictuelle',
  tripsCalendarPage_BusBrand: 'Marque du bus',
  tripsCalendarPage_OnlyShowSameBusModel: 'Afficher uniquement les mêmes modèles de bus',
  // trip details
  tripDetailsPage_Title: 'Détails du voyage',
  tripDetailsPage_DepartureDate: 'Date de départ',
  tripDetailsPage_SourceStation: 'Station source',
  tripDetailsPage_DestinationStation: 'Gare de destination',
  tripDetailsPage_SeatingModel: 'Modèle de siège',
  tripDetailsPage_Route: 'Itinéraire',
  tripDetailsPage_Stops: 'Escales',
  tripDetailsPage_TripRefNumber: 'Numéro de référence',
  tripDetailsPage_SearchText: 'Nom du voyage...',
  tripDetailsPage_TripName: 'Nom du voyage',
  tripDetailsPage_SourceCountry: `Pays d'origine`,
  tripDetailsPage_DestinationCountry: 'Pays de destination',
  tripDetailsPage_ChangeStatus: 'Modifier le statut',
  tripDetailsPage_Status: 'Statut',
  tripDetailsPage_CurrentStatus: 'Gare actuelle',
  tripDetailsPage_NextStation: 'Prochaine gare',
  tripDetailsPage_NewStatus: 'Nouveau statut',
  tripDetailsPage_Remarks: 'Remarques',
  tripDetailsPage_DelayedTime: 'Temps de retard (minutes)',
  // terminals (P35)
  terminalsPage_Title: "Terminaux",
  terminalsPage_Intro: "Un terminal est un appareil (Sunmi T2, T2s, V3 MIX…) rattaché à une gare ou à un véhicule. Il est enregistré une seule fois avec un code à usage unique, puis utilisé par plusieurs agents.",
  terminalsPage_Create: "Créer un terminal",
  terminalsPage_CreateOk: "Créer et obtenir le code",
  terminalsPage_Name: "Nom",
  terminalsPage_NamePlaceholder: "ex. Guichet Ouaga – T2s",
  terminalsPage_Scope: "Périmètre",
  terminalsPage_Station: "Gare",
  terminalsPage_Vehicle: "Véhicule",
  terminalsPage_Status: "Statut",
  terminalsPage_Status_PendingEnrollment: "En attente d'enregistrement",
  terminalsPage_Status_Active: "Actif",
  terminalsPage_Status_Revoked: "Révoqué",
  terminalsPage_DeviceModel: "Modèle",
  terminalsPage_LastSeen: "Dernière utilisation",
  terminalsPage_LastAgent: "Dernier agent",
  terminalsPage_Actions: "Actions",
  terminalsPage_NewCode: "Nouveau code",
  terminalsPage_NewCodeConfirmTitle: "Nouveau code d'enregistrement pour « {{name}} » ?",
  terminalsPage_NewCodeConfirmContent: "Pour réinstaller ou remplacer l'appareil. L'installation actuelle cesse de fonctionner jusqu'à la saisie du nouveau code.",
  terminalsPage_Revoke: "Révoquer",
  terminalsPage_RevokeTitle: "Révoquer « {{name}} » ?",
  terminalsPage_RevokeWarning: "Définitif : l'appareil ne peut plus ouvrir de session et ses certificats sont révoqués (terminal perdu ou volé).",
  terminalsPage_RevokeReason: "Motif",
  terminalsPage_Revoked: "Terminal révoqué",
  terminalsPage_CodeTitle: "Code d'enregistrement de « {{name}} »",
  terminalsPage_CodeOnce: "Ce code n'est affiché qu'une fois : copiez-le maintenant.",
  terminalsPage_CodeValidity: "Valable 24 h (jusqu'au {{date}}), à usage unique.",
  terminalsPage_CodeHowTo: "Sur le terminal, après la connexion d'un agent : Réglages › Terminal, saisir le code, puis « Enregistrer ce terminal ».",
  terminalsPage_CodeDone: "J'ai copié le code",
  terminalsPage_Error: "L'opération a échoué",
  TerminalNotFound: "Terminal introuvable",
  TerminalRevoked: "Ce terminal est révoqué",
  InvalidLanguage: "Langue inconnue (français ou anglais attendu)",
  TerminalNameRequired: "Nom du terminal obligatoire",
  TerminalScopeInvalid: "Gare ou véhicule introuvable dans votre compagnie",
  // Étape 5 (2026-11-02) : clés qui n'existaient qu'en anglais.
  companySettingsPage_CompanyUrl: 'Adresse du site de la compagnie',
  companySettingsPage_TicketModificationSetting: 'Modification des billets',
  companySettingsPage_TicketModificationLimitTime: 'Délai limite de modification des billets',
  companySettingsPage_SellOnTheGoSetting: 'Vente en route',
  companySettingsPage_SellOnTheGoBaseTariff: 'Tarif de base par segment',
  companySettingsPage_BaseTariffParameter: 'Paramètres du tarif de base',
  stationsPage_IsGlobalStation: 'Gare commune',
  seatModelsPage_AddSeats: 'Ajouter des sièges',
  busesPage_StartDate: 'Date de début',
  busesPage_ExpirationDate: 'Date d\'expiration',
  busesPage_BusInsurances: 'Assurances du car',
  busesPage_AddBisInsurancePolicy: 'Ajouter une police d\'assurance',
  busesPage_InsuranceDetail: 'Détail de l\'assurance',
  busesPage_PolicyNumber: 'Numéro de police',
  baggageTariffsPage_Title: 'Tarifs bagages',
  baggageTariffsPage_UpdateBaggageTariffs: 'Mettre à jour les tarifs bagages',
  baggageTariffsPage_From: 'De',
  baggageTariffsPage_To: 'À',
  baggageTariffsPage_FreeBag: 'Bagages gratuits',
  baggageTariffsPage_MaxBag: 'Bagages maximum',
  baggageTariffsPage_SecondTariff: 'Tarif bagage 2',
  baggageTariffsPage_TarrifBagageMoto: 'Tarif bagage moto',
  baggageTariffsPage_TicketClass: 'Classe de billet',
  baggageTariffsPage_TarrifBagage: 'Tarif bagage',
  baggageTariffsPage_SearchText: 'Gare de départ, d\'arrivée…',
  baggageTariffsPage_CreateNewSegment: 'Créer un segment',
  baggageTariffsPage_SelectRoute: 'Itinéraire',
  baggageTariffsPage_UpdateTicketTariffs: 'Mettre à jour les tarifs des billets',
  ticketTariffsPage_Segment_ReturnValue: 'Valeur aller-retour',
  ticketTariffsPage_Segment_ApplyForAllSegments: 'Appliquer à tous les segments',
  ticketTariffsPage_Segment_ApplyForAllSegmentsConfirm: 'Appliquer ce tarif à tous les segments ?',
  tripsPage_ActiveOrInActive: 'Trajet actif / inactif',
  tripsPage_Map: 'Carte',
  discountsPage_Name: 'Nom',
  discountsPage_Route: 'Itinéraire',
  discountsPage_Segment: 'Segment',
  discountsPage_AllPassengers: 'Tous les passagers',
  discountsPage_AllTicketClasses: 'Toutes les classes de billet',
  discountsPage_AllTariffParameters: 'Tous les paramètres de tarif',
  discountsPage_AllTrips: 'Tous les trajets',
  discountsPage_AllRoutes: 'Tous les itinéraires',
  discountsPage_AllSegments: 'Tous les segments',
  tripsCalendarPage_IncludePassingStation: 'Inclure les gares de passage',
  tripDetailsPage_ActualTime: 'Heure réelle',
  tripDetailsPage_ExportPassenger: 'Exporter les passagers',
  tripDetailsPage_ExportPassengerPdf: 'Exporter en PDF',
  tripDetailsPage_SendReportToEmail: 'Envoyer le rapport par e-mail',
  registerPage_Title: 'Caisses',
  registerPage_Name: 'Nom',
  registerPage_StationName: 'Gare',
  registerPage_RegisterStatus: 'Statut',
  registerPage_Cashiers: 'Caissiers',
  registerPage_OpeningHours: 'Heures d\'ouverture',
  registerPage_OpeningHoursFrom: 'Ouverture à partir de',
  registerPage_OpeningHoursTo: 'Fermeture à',
  registerPage_StartingCash: 'Fonds de caisse',
  registerPage_CurrentBalance: 'Solde actuel',
  registerPage_CreateRegister: 'Créer une caisse',
  registerPage_UpdateRegister: 'Modifier la caisse',
  registerPage_ChangePin: 'Changer le PIN',
  registerPage_NewPin: 'Nouveau PIN',
  registerPage_PrintDestination: 'Imprimer la destination',
  registerPage_ReceiptDefaultPrinter: 'Imprimante des reçus',
  registerPage_TicketDefaultPrinter: 'Imprimante des billets',
  registerPage_ShipmentLabelDefaultPrinter: 'Imprimante des étiquettes de colis',
  registerPage_loyaltyClient: 'Client fidélité',
  registerPage_ActionAnnulation: 'Annulation',
  registerPage_RegisterInfo: 'Informations de la caisse',
  registerPage_ChangeToClose: 'Passer au statut Fermée',
  registerPage_ChangeToReady: 'Passer au statut Prête',
  registerPage_ResetPin: 'Réinitialiser le PIN',
  registerPage_ResetPinConfirm: 'Réinitialiser le PIN de cet utilisateur ?',
  registerPage_ResetPinSuccess: 'Le nouveau PIN a été envoyé à l\'utilisateur (SMS ou e-mail)',
  registerPage_TicketPayments: 'Paiements des billets',
  registerPage_PayMode: 'Mode de paiement',
  registerPage_CashierName: 'Caissier',
  registerPage_RechargeWithdraw: 'Approvisionnement et retrait de caisse',
  registerPage_SelectAction: 'Choisir l\'opération',
  registerPage_AmountToTransfer: 'Montant à transférer',
  registerPage_ProcessAction: 'Valider l\'opération',
  registerPage_GlobalRegisterTitle: 'Caisses communes',
  ticketBooking_BookingRefNo: 'N° de réservation',
  ticketBooking_TicketRefNo: 'N° de billet',
  ticketBooking_Passenger: 'Passager',
  ticketBooking_SeatNo: 'N° de siège',
  ticketBooking_BookingDate: 'Date de réservation',
  ticketBooking_TicketClassName: 'Classe de billet',
  ticketBooking_FromStation: 'Gare de départ',
  ticketBooking_ToStation: 'Gare d\'arrivée',
  ticketBooking_FromCity: 'Ville de départ',
  ticketBooking_ToCity: 'Ville d\'arrivée',
  manageTicket_Title: 'Gestion des billets',
  manageTicket_CancelTicket: 'Annuler le billet',
  manageTicket_UpdatePassenger: 'Modifier le passager',
  manageTicket_IsMainPassenger: 'Passager principal',
  manageTicket_UpdatePassengerIdentity: 'Modifier l\'identité du passager',
  manageTicket_UploadDocuments: 'Ajouter des documents',
  registerReconciliation_Title: 'Rapprochement de caisse',
  registerReconciliation_Cashier: 'Caissier',
  registerReconciliation_PaymentDate: 'Date de paiement',
  registerReconciliation_NoOfPassengers: 'Nombre de passagers',
  registerReconciliation_OutStandingAmount: 'Montant restant',
  registerReconciliation_CancelledAmount: 'Montant annulé',
  registerReconciliation_CashierName: 'Nom du caissier',
  registerReconciliation_LastReconciliation: 'Dernier rapprochement',
  registerReconciliation_SelectCashier: 'Choisir un caissier',
  registerReconciliation_BookingTotalAmount: 'Total des réservations',
  registerReconciliation_ShipmentTotalAmount: 'Total des colis',
  registerReconciliation_ParkingTotalAmount: 'Total du parking',
  registerReconciliation_ExpenseTotalAmount: 'Total des dépenses',
  registerReconciliation_IsAmountVerified: 'Montant vérifié',
  registerReconciliation_AmountDifference: 'Écart',
  registerReconciliation_LogReconciliation: 'Enregistrer le rapprochement',
  ticketModificationSetting_Title: 'Modification des billets',
  ticketModificationSetting_TicketCondition: 'Condition du billet',
  ticketModificationSetting_AllowToModifyTicket: 'Modification autorisée',
  ticketModificationSetting_IsPercentageBase: 'En pourcentage',
  ticketModificationSetting_Amount: 'Montant',
  ticketModificationSetting_Create: 'Nouveau réglage',
  ticketModificationSetting_Update: 'Modifier',
  cancellationPolicyPage_Title: 'Politiques d\'annulation',
  cancellationPolicyPage_TicketCondition: 'Condition du billet',
  cancellationPolicyPage_IsPercentageBase: 'En pourcentage',
  cancellationPolicyPage_CheckinTime: 'Heure d\'enregistrement',
  cancellationPolicyPage_Plans: 'Plans',
  cancellationPolicyPage_Hours: 'Heures',
  cancellationPolicyPage_Amount: 'Montant',
  cancellationPolicyPage_Create: 'Créer',
  cancellationPolicyPage_Update: 'Modifier',
  cancellationPolicyPage_DuplicateHoursError: 'Ce nombre d\'heures existe déjà',
  pdfTemplatesPage_Title: 'Modèles PDF',
  pdfTemplatesPage_Name: 'Nom',
  pdfTemplatesPage_CultureCode: 'Langue',
  pdfTemplatesPage_Content: 'Contenu',
  pdfTemplatesPage_CreatePdfTemplate: 'Créer un modèle PDF',
  pdfTemplatesPage_UpdatePdfTemplate: 'Modifier le modèle PDF',
  bookingPage_Title: 'Gestion des réservations',
  bookingPage_NoOfPassenger: 'Nombre de passagers',
  bookingPage_DepartureDate: 'Date de départ',
  bookingPage_ArrivalDateTime: 'Date d\'arrivée',
  bookingPage_TicketConditions: 'Conditions du billet',
  bookingPage_TicketClasses: 'Classes de billet',
  bookingPage_ReceiptRefNo: 'N° de reçu',
  bookingPage_PassengerName: 'Nom du passager',
  bookingPage_ViewTickets: 'Voir les billets',
  bookingPage_DownloadPdf: 'Télécharger le PDF',
  bookingPage_PrintTicket: 'Imprimer le billet',
  bookingPage_Tickets: 'Billets',
  bookingPage_Comments: 'Commentaires',
  bookingPage_ChangeDate: 'Changer la date',
  bookingPage_ChangeValues: 'Changer les valeurs',
  bookingPage_BookingHistory: 'Historique de la réservation',
  bookingPage_TripHistory: 'Historique du trajet',
  bookingPage_HasBaggage: 'Avec bagages',
  ticketConflictPage_Title: 'Gestion des conflits de billets',
  ticketConflictPage_TripCode: 'Code du trajet',
  ticketConflictPage_ConflictReason: 'Motif du conflit',
  ticketConflictPage_ChangeSeat: 'Changer de siège',
  ticketConflictPage_ChangeTrip: 'Changer de trajet',
  ticketConflictPage_CancelTicket: 'Annuler le billet',
  ticketConflictPage_TicketRefNo: 'N° de billet',
  ticketConflictPage_TripAmount: 'Montant du trajet',
  ticketConflictPage_TicketAmount: 'Montant du billet',
  ticketConflictPage_SeatingModelName: 'Plan de sièges',
  companyRolesPage_Title: 'Rôles',
  companyRolesPage_RoleName: 'Nom du rôle',
  companyRolesPage_Permissions: 'Permissions',
  companyRolesPage_NormalizedName: 'Nom normalisé',
  companyRolesPage_IsAdminRole: 'Rôle d\'administration',
  companyRolesPage_IsTransportRole: 'Rôle transport',
  companyRolesPage_IsPOSRole: 'Rôle point de vente',
  companyRolesPage_AddNewRole: 'Ajouter un rôle',
  companyRolesPage_UpdateRole: 'Modifier le rôle',
  baggageReconciliation_Title: 'Rapprochements des bagages',
  baggageReconciliation__SelectCheckInUser: 'Choisir l\'agent d\'enregistrement',
  baggageReconciliation__TripName: 'Trajet',
  baggageReconciliation__BookingDate: 'Date de réservation',
  shipmentManagementPage_Title: 'Gestion des colis',
  shipmentManagementPage_ShipmentTariffs: 'Tarifs des colis',
  shipmentManagementPage_BoxCategory: 'Catégorie de colis',
  shipmentManagementPage_CreateBoxCategory: 'Créer une catégorie de colis',
  shipmentManagementPage_UpdateBoxCategory: 'Modifier la catégorie de colis',
  shipmentManagementPage_BoxType: 'Type de colis',
  shipmentManagementPage_CreateBoxType: 'Créer un type de colis',
  shipmentManagementPage_UpdateBoxType: 'Modifier le type de colis',
  shipmentManagementPage_BoxVolume: 'Volume du colis',
  shipmentManagementPage_CreateBoxVolume: 'Créer un volume de colis',
  shipmentManagementPage_UpdateBoxVolume: 'Modifier le volume de colis',
  shipmentManagementPage_BoxWeight: 'Poids du colis',
  shipmentManagementPage_CreateBoxWeight: 'Créer un poids de colis',
  shipmentManagementPage_UpdateBoxWeight: 'Modifier le poids de colis',
  shipmentManagementPage_TariffAmount: 'Montant du tarif',
  shipmentManagementPage_CreateTariffAmount: 'Créer un montant de tarif',
  shipmentManagementPage_UpdateTariffAmount: 'Modifier le montant du tarif',
  shipmentManagementPage_CancellationPolicy: 'Politique d\'annulation',
  shipmentManagementPage_UpdateCancellationPolicy: 'Modifier la politique d\'annulation',
  shipmentManagementPage_BeforeAssignTripAmount: 'Montant avant affectation au trajet',
  shipmentManagementPage_IsPercentageBase: 'En pourcentage',
};
export default companyFrPages;
